import {
    SET_PAYMENT_GATEWAY_STATUS_START,
    SET_PAYMENT_GATEWAY_STATUS_SUCCESS,
    SET_PAYMENT_GATEWAY_STATUS_ERROR
} from '../../constants';
import showToaster from '../../helpers/showToaster';
import { getAllPaymentMethods as query, updatePaymentGateWayStatus as mutation } from '../../lib/graphql';

export function updatePaymentGatewayStatus(id, isEnable) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: SET_PAYMENT_GATEWAY_STATUS_START
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    id,
                    isEnable
                },
                refetchQueries: [{ query }]
            });

            if (data?.updatePaymentGatewayStatus?.status == 200) {
                dispatch({
                    type: SET_PAYMENT_GATEWAY_STATUS_SUCCESS
                });
                showToaster({ messageId: 'paymentGateway', toasterType: 'success' })
                return true;
            } else {
                dispatch({
                    type: SET_PAYMENT_GATEWAY_STATUS_ERROR
                });
                showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.updatePaymentGatewayStatus?.errorMessage })
            }
        } catch (error) {
            dispatch({
                type: SET_PAYMENT_GATEWAY_STATUS_ERROR
            });
            showToaster({ messageId: 'updateFailed', toasterType: 'error' })
        }
    }
}